import { Pipe, PipeTransform } from '@angular/core';
import { marker as t } from '@biesbjerg/ngx-translate-extract-marker';
import { GenderEnum } from '@enums/gender.enum';

@Pipe({
  name: 'genderPipe',
})
export class GenderPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case GenderEnum.Female:
        return t('GENDER_OPTIONS.FEMALE');
      case GenderEnum.Male:
        return t('GENDER_OPTIONS.MALE');
      default:
        break;
    }
  }
}
